import { createFileRoute, redirect } from '@tanstack/react-router';
import { validateDiagnosisSearch } from '../diagnosis/$uuid';

/**
 * CadMorph is part of the Diagnosis workspace now (ENG-2742). Old links —
 * the assistant's, a study's "Optimize in CadMorph", bookmarks — land there
 * with their study, design point and conversation intact.
 */
export const redirectCadMorphToDiagnosis = ({
  params,
  search,
}: {
  params: { uuid: string };
  search: ReturnType<typeof validateDiagnosisSearch>;
}) => {
  throw redirect({ to: '/diagnosis/$uuid', params, search, replace: true });
};

export const Route = createFileRoute('/_app/cadmorph/$uuid')({
  validateSearch: validateDiagnosisSearch,
  beforeLoad: redirectCadMorphToDiagnosis,
});
